import { motion } from 'framer-motion';

const eventTypes = ['Tous', 'Conférence', 'Excursion', 'Goûter'];

export default function EventFilter({ currentFilter, onFilterChange }) {
    return (
        <div className="flex flex-wrap gap-2 justify-center mb-12">
            {eventTypes.map((type) => (
                <button
                    key={type}
                    onClick={() => onFilterChange(type)}
                    className="relative px-6 py-2 rounded-full text-sm font-medium transition-colors focus:outline-none"
                >
                    {currentFilter === type && (
                        <motion.div
                            layoutId="activeFilter"
                            className="absolute inset-0 bg-primary-900 rounded-full"
                            transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                        />
                    )}
                    <span className={`relative z-10 ${currentFilter === type ? 'text-white' : 'text-gray-600 hover:text-primary-900'}`}>
                        {type}
                    </span>
                </button>
            ))}
        </div>
    );
}
